import React from "react";
import { Button, Card, Col, Row, Typography, Popover } from "antd";
import FacilitiesSelect, { FacilityOption } from "components/FacilitiesSelect/FacilitiesSelect";
import { ManualStockEntryStockType } from "services/BillingEngineService/interfaces/entities/ManualStockEntry";
import StockTypeSelect from "../StockTypeSelect";

interface ManualStockHoursHeader {
  canUpdateStock?: boolean;
  updatesEnabled: boolean;
  selectedFacility?: FacilityOption;
  onFacilitySelect: (value: FacilityOption) => void;
  selectedStockType?: ManualStockEntryStockType;
  onStockTypeSelect: (value: ManualStockEntryStockType) => void;
  onUpdatePress: () => void;
}

function ManualStockHoursHeader({
  selectedFacility,
  onFacilitySelect,
  selectedStockType,
  onStockTypeSelect,
  onUpdatePress,
  canUpdateStock = false,
  updatesEnabled,
}: ManualStockHoursHeader) {
  const unableToUpdateContent = (
    <div>
      <p>It's too late to update stock entries for today!</p>
    </div>
  );

  const updateStockButton = updatesEnabled ? (
    <Button type="primary" onClick={onUpdatePress}>
      Update Stock
    </Button>
  ) : (
    <Popover content={unableToUpdateContent}>
      <Button type="primary" disabled={!updatesEnabled} onClick={onUpdatePress}>
        Update Stock
      </Button>
    </Popover>
  );

  return (
    <Card style={{ position: "relative" }}>
      <Row gutter={30} align="middle">
        <Col>
          <Typography.Title style={{ margin: 0 }}>Warehouse Stock</Typography.Title>
        </Col>

        <Col span={6}>
          <FacilitiesSelect selectedValue={selectedFacility?.name} onSelect={onFacilitySelect} />
        </Col>
        <Col span={6}>
          <StockTypeSelect value={selectedStockType} onSelect={onStockTypeSelect} />
        </Col>
      </Row>

      {canUpdateStock && (
        <div
          style={{
            position: "absolute",
            right: 20,
            top: "50%",
            transform: "translate(0, -50%)",
          }}
        >
          {updateStockButton}
        </div>
      )}
    </Card>
  );
}

export default ManualStockHoursHeader;
